export function round(value, decimals = 2) {
  if (value == null || Number.isNaN(value)) return null;
  // pre round to avoid floating point issues, but don't clip below target precision
  const preRound = Math.min(Math.max(decimals + 2, 5), 12);
  const newValue = Math.round(value * 10 ** preRound) / 10 ** preRound;
  return Math.round(newValue * 10 ** decimals) / 10 ** decimals;
}
